module.exports = "<p>\n  city-survey works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/city-survey/city-survey.component.html
// module id = ../../../../../src/app/city-survey/city-survey.component.html
// module chunks = main